import { render, staticRenderFns } from "./LikeTable.vue?vue&type=template&id=61b6a243&"
import script from "./LikeTable.vue?vue&type=script&lang=js&"
export * from "./LikeTable.vue?vue&type=script&lang=js&"
import style0 from "./LikeTable.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports